export default __webpack_public_path__ + "static/colombia-b30eb7798fde9d86ce39be72198e7064.jpg";